import {
  ChevronFirst,
  ChevronLast,
  ChevronLeftIcon,
  ChevronRightIcon,
  Maximize2,
  Minimize2,
  Minus,
  Plus,
} from "lucide-react";
import ControlsButton from "./ControlsButton";

interface PdfControlsProps {
  isFullScreen: boolean;
  setIsFullScreen: (value: boolean) => void;
  setPage: (value: number) => void;
  page: number;
  maxPage: number | null;
  className?: string;
  scale: number;
  onZoomIn: () => void;
  onZoomOut: () => void;
  onResetZoom: () => void;
}

const PdfControls: React.FC<PdfControlsProps> = ({
  setPage,
  page,
  maxPage,
  className,
  isFullScreen,
  setIsFullScreen,
  scale,
  onZoomIn,
  onZoomOut,
  onResetZoom,
}) => {
  return (
    <div className={`${className}`}>
      <div className='text-sm text-gray-500 text-center mb-1'>
        Page {page} sur {maxPage || "-"}
      </div>
      <div className='flex flex-row gap-1 md:gap-2 justify-center items-center'>
        <ControlsButton disabled={page <= 1} onClick={() => setPage(1)} icon={<ChevronFirst />} />
        <ControlsButton disabled={page <= 1} onClick={() => setPage(page - 1)} icon={<ChevronLeftIcon />} />
        <ControlsButton
          disabled={page >= (maxPage || 0)}
          onClick={() => setPage(page + 1)}
          icon={<ChevronRightIcon />}
        />
        <ControlsButton
          disabled={page >= (maxPage || 0)}
          onClick={() => setPage(maxPage || 0)}
          icon={<ChevronLast />}
        />
        <ControlsButton
          disabled={false}
          onClick={() => setIsFullScreen(!isFullScreen)}
          icon={isFullScreen ? <Minimize2 className='w-6 h-6' /> : <Maximize2 className='w-6 h-6' />}
        />
        <div className='flex items-center gap-1 md:gap-2'>
          <button onClick={onZoomOut} className='p-2 rounded hover:bg-gray-100' title='Zoom out'>
            <Minus className='w-4 h-4' />
          </button>
          <button onClick={onResetZoom} className='p-2 rounded hover:bg-gray-100' title='Reset zoom'>
            {Math.round(scale * 100)}%
          </button>
          <button onClick={onZoomIn} className='p-2 rounded hover:bg-gray-100' title='Zoom in'>
            <Plus className='w-4 h-4' />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PdfControls;
